import React, { useEffect, useState } from "react";
import ApexChartContainer from "apex-charts/apex-chart-container";
import WordsBlock from "pages/extended-analytic/analytic/words-block/words-block";
import Metrics from "./Metrics/Metrics";
import s from "./analytic.module.scss";

const Analytics = (props) => {
    const getLocations = (location) => {
        let name = props.locationsName && props.locationsName[location] ? props.locationsName[location] : location
        return name
    }

    const getData = (data) => {
        /*let res = {}
        res = data*/
        if(data.chartId === "AuthorsLocations"){
            data.labels = props.locationsName ? data.labels.map(k => getLocations(k)) : data.labels
        }
        return data
    }

    const [firstData, setFirstData] = useState(getData(props.firstData));
    const [secondData, setSecondData] = useState(props.secondData ? props.secondData : props.secondData);
    const [thirdData, setThirdData] = useState(props.thirdData ? props.thirdData : props.thirdData)
    const [firstMax, setFirstMax] = useState(props.firstMax);
    const [secondMax, setSecondMax] = useState(props.secondMax);
    const [metricData, setMetricData] = useState(props.metric);
    //const [firstHeight, setFirstHeight] = useState(firstData.height);
    const [secondHeight, setSecondHeight] = useState(secondData.height);
    const [firstWidth, setFirstWidth] = useState(firstData.width);
    const [secondWidth, setSecondWidth] = useState(firstData.width);

    useEffect(() => {
        setFirstData(getData(props.firstData));
        setSecondData(props.secondData ? props.secondData : props.secondData);
        setThirdData(props.thirdData ? props.thirdData : props.thirdData);
        setMetricData(props.metric);
        setFirstMax(props.firstMax);
        setSecondMax(props.secondMax);
        //setFirstHeight(firstData.height);
        setSecondHeight(secondData.height);
        setFirstWidth(firstData.width);
        setSecondWidth(firstData.width);
    }, [props.firstData, props.secondData, props.thirdData, props.metric, props.deviceType])

    let firstHeight = firstData.height//firstData.chartId === 'AuthorsSentiment' || firstData.chartId === 'MediaType' || firstData.chartId === 'AuthorsLocations' || firstData.chartId === 'Top20' || firstData.chartId === 'KeyWords' ? 450 : 290
    //let secondHeight = secondData.height//secondData.chartId === 'FollowersCount' || secondData.chartId === 'Top20Languages'  ? 450 : 290
    let thirdHeight = thirdData.height
    //let firstWidth = firstData.width
    //let secondWidth = secondData.width
    let thirdWidth = thirdData.width
   
    const setMaximum = (chart, max) => {
        props.setMaxData(chart, max)
    }

    const getMetricItems = (items) => {
        let res = items && items.length ? items.map(k => {return {name: k.name, list: k.list, data: (k.data && k.data.length) ? k.data.reduce((a, b) => a + b, 0) : []}}) : [];
        return res
    }

    return <div className={s.Analytics}>
        <div style={{width: '100%'}}>
        {((firstData && firstData.chartId === 'KeyWords') || (thirdData && thirdData.chartId === 'PopularWords' ) || (firstData.chartId === 'Tags')) 
        && <WordsBlock data={thirdData} getValue={props.getValue} pageType={thirdData.chartId}/>}
        </div>
        <div className={s.AnalyticsContainerBlock} ><div className={s.AnalyticChart} style={ props.deviceType === 'mobile' || props.deviceType === 'tablet' ?  { width : '100%', height: firstHeight} : firstData && firstData.metric ? {width: 'calc(100% - 360px)', height: firstHeight} : {width : '100%', height: firstHeight}}>
            {firstData && firstData.data && firstData.data.length ? 
                <div className={s.AnalyticsRow}><ApexChartContainer 
                                    height={firstHeight}
                                    width={'100%'}
                                    setMax={setMaximum.bind(this, 'first')} 
                                    showLimit={firstData.max ? firstMax : null}
                                    title={firstData.title}
                                    type={firstData.chartType} 
                                    getValue={props.getValue} 
                                    data={{values: firstData.data, labels: firstData.labels, topicIDs: firstData.topicIDs}} 
                                    labels={firstData.labels} 
                                    colors={firstData.colors}
                                    fields={firstData.fields}
                                    fieldsType={firstData.fieldsType}
                                    legendPosition={firstData.chartId === "AuthorsLocations" && props.deviceType === 'mobile' ? 'bottom' : 'right'}
                                    stacked={true}
                                    legend={true}
                /></div> : <div></div>}
                
        </div>{metricData && metricData.total > 0 && metricData.position === 'first' ? <Metrics getValue={props.getValue} metricsData={metricData}/> : null}
        </div>
        {secondData && secondData.data && secondData.data.length 
            ? <div className={s.AnalyticsContainerBlock} data-block={'second'}>
                <div className={s.AnalyticChart} style={secondData && secondData.metric ? {width: 'calc(100% - 360px)'} : {width: '100%'}}>
            
                <ApexChartContainer 
                                    height={secondHeight}
                                    width={'100%'}
                                    setMax={setMaximum.bind(this, 'second')} 
                                    showLimit={secondData.max ? secondMax : null}
                                    title={secondData.title}
                                    type={secondData.chartType} 
                                    getValue={props.getValue} 
                                    data={{values: secondData.data, labels: secondData.labels, topicIDs: secondData.topicIDs}} 
                                    labels={secondData.labels} 
                                    colors={secondData.colors}
                                    fields={secondData.fields}
                                    fieldsType={secondData.fieldsType}
                                    stacked={true}
                                    legend={true}
                                    /> 
                
            </div>{metricData && metricData.total > 0 && metricData.position === 'second' ? <Metrics selectedLanguage={props.selectedLanguage} getValue={props.getValue} metricsData={metricData}/> : null}</div>
        : <div></div>}
        {thirdData && thirdData.data && thirdData.data.length && ((firstData && firstData.chartId !== 'KeyWords') && (firstData && firstData.chartId !== 'PopularWordsBurst' ) && (firstData.chartId !== 'Tags')) ?
            <div className={s.AnalyticsContainerBlock}>
                <div className={s.AnalyticChart} 
                        style={{width: '100%'}}
                >
                <ApexChartContainer 
                    height={thirdHeight}
                    width={'100%'}
                    setMax={setMaximum.bind(this, 'third')} 
                    showLimit={thirdData.max ? firstMax : null}
                    title={thirdData.title}
                    type={thirdData.chartType} 
                    getValue={props.getValue} 
                    data={{values: thirdData.data, labels: thirdData.labels, topicIDs: thirdData.topicIDs}} 
                    labels={thirdData.labels} 
                    colors={thirdData.colors}
                    fields={thirdData.fields}
                    fieldsType={thirdData.fieldsType}
                    legendPosition={thirdData.chartId === "AuthorsLocations" && props.deviceType === 'mobile' ? 'bottom' : 'right'}
                    stacked={true}
                    legend={true}
                /></div></div> : null
        }
    </div>
}

export default Analytics